import styled from '@emotion/styled';
import { mediaMax, spacing } from 'presentations/views/styles';
import LoginButton from 'presentations/views/components/atoms/LoginButton';
import { SyntheticEvent } from 'react';
import { Provider } from 'domains/models/account/providerType';

interface Props {
  isLoading?: boolean;
  isLogin: boolean;
  providers?: string[] | null;
  onClickService: any;
  loadingProvider?: Provider | null;
}

export default function Component(props: Props) {
  const variant = props.isLogin ? 'login' : 'signup';
  const isUnknown = !props.providers || props.providers.length === 0;
  const providers = [
    Provider.Google,
    Provider.Microsoft,
    Provider.Apple,
    // Provider.Slack,
    // Provider.Facebook,
  ].filter((p) => {
    return props.providers?.includes(p) || isUnknown;
  });
  return (
    <Container>
      {providers.map((p: any) => (
        <FormField key={p}>
          <LoginButton
            isLoading={props.isLoading && props.loadingProvider === p}
            isOwner={props.providers?.includes(p)}
            isDisabled={props.isLoading}
            service={p}
            variant={variant}
            onClick={(e: SyntheticEvent<HTMLInputElement>) =>
              props.onClickService(e, p)
            }
          />
        </FormField>
      ))}
    </Container>
  );
}

const Container = styled.div`
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  ${mediaMax.desktop} {
    width: 100%;
    flex-direction: column;
    justify-content: center;
  }
`;

const FormField = styled.div`
  margin: 0 ${spacing(8)} ${spacing(16)};
  ${mediaMax.tablet} {
  }
  :last-of-type {
    margin-bottom: 0;
  }
`;
